/**
 * Shared shadcn card shell for Statistics charts.
 * Horizontal inset matches Chakra `Card` theme padding (22px) used by RiskMetricsCard.
 */

import { cn } from "@/lib/utils";

/** @see src/theme/additions/card/Card.ts — baseStyle.p */
export const STATISTICS_CHAKRA_CARD_PADDING_PX = 22;

/** Statistics cards in dark mode match Trade Log / dashboard sidebar surfaces. */
export const statisticsSidebarSurfaceCardClassName =
  "dark:bg-sidebar dark:text-sidebar-foreground";

/** Single 1px border — matches Chakra Risk Metrics (`border="1px solid"`), not ring + border. */
export const statisticsShadcnCardClassName = cn(
  "flex w-full min-w-0 flex-col gap-0 overflow-visible rounded-md border border-solid border-border bg-card py-0 shadow-none ring-0",
  statisticsSidebarSurfaceCardClassName,
);

export const statisticsShadcnCardHeaderClassName =
  "items-center px-[22px] pb-0 pt-[22px]";

export const statisticsShadcnCardContentClassName =
  "flex-1 overflow-visible px-[22px] pb-[22px] pt-2";

/** Inset plot area so donut strokes are not clipped by the card chrome. */
export const statisticsShadcnCardChartAreaClassName =
  "flex w-full justify-center overflow-visible px-2 pb-1";

export const statisticsShadcnChartContainerClassName =
  "mx-auto aspect-square max-h-[230px] w-full min-w-0 [&_.recharts-surface]:overflow-visible [&_.recharts-wrapper]:!overflow-visible";

/** Bar chart plot inset (P&L over time, weekly breakdown, etc.). */
export const statisticsShadcnBarChartAreaClassName =
  "w-full overflow-visible px-1 pb-1";

export const statisticsShadcnBarChartContainerClassName =
  "aspect-auto h-[380px] w-full min-w-0 [&_.recharts-surface]:overflow-visible [&_.recharts-wrapper]:!overflow-visible";

export const statisticsShadcnDailyActivityChartContainerClassName =
  "aspect-auto h-[300px] w-full min-w-0 [&_.recharts-surface]:overflow-visible [&_.recharts-wrapper]:!overflow-visible";

export const statisticsShadcnTimeAnalysisChartContainerClassName =
  "aspect-auto h-[350px] w-full min-w-0 [&_.recharts-surface]:overflow-visible [&_.recharts-wrapper]:!overflow-visible";

/** Plot inset for Time Analysis signed P&L bar charts. */
export const statisticsTimeAnalysisBarChartMargin = {
  top: 16,
  right: 24,
  left: 16,
  bottom: 20,
} as const;
